module.exports = MaterialUI.CardContent;